import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isAdmin } = useAuth();

  if (!user) {
    toast.info('Bitte melden Sie sich an, um auf diese Seite zuzugreifen.');
    return <Navigate to="/" replace />;
  }

  if (adminOnly && !isAdmin()) {
    toast.error('Sie haben keine Berechtigung für diese Seite.');
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
